import { render, staticRenderFns } from "./PcAdvisorNoAccess.vue?vue&type=template&id=ef013c94&scoped=true"
import script from "./PcAdvisorNoAccess.vue?vue&type=script&lang=js"
export * from "./PcAdvisorNoAccess.vue?vue&type=script&lang=js"
import style0 from "./PcAdvisorNoAccess.vue?vue&type=style&index=0&id=ef013c94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef013c94",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
